module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BreadcrumbFirstItem":{"text":"Úvod"}}}')
  delete Component.options._Ctor
}
